import Password2FaS1 from "@/assets/png/Password2Fa/Password2FaS1.png";
import Password2FaS2 from "@/assets/png/Password2Fa/Password2FaS2.png";
import Password2FaS3 from "@/assets/png/Password2Fa/Password2FaS3.png";
import Password2FaS4 from "@/assets/png/Password2Fa/Password2FaS4.png";
import Password2FaS5 from "@/assets/png/Password2Fa/Password2FaS5.png";
import Password2FaS6 from "@/assets/png/Password2Fa/Password2FaS6.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const password2FaQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. Which of the following passwords is considered most secure?",
    options: [
      { value: "1", label: "12345678" },
      { value: "2", label: "qwerty" },
      { value: "3", label: "MyDog2020" },
      { value: Answer.Correct, label: "W$9d@3L!g*8T" },
    ],
  },
  {
    name: "step2",
    question: "2. What is two-factor authentication (2FA)?",
    options: [
      { value: "1", label: "When only a password is required" },
      {
        value: Answer.Correct,
        label: "An additional verification step besides the password",
      },
      { value: "3", label: "Typing the password twice" },
      { value: "4", label: "A way to reset a password" },
    ],
  },
  {
    name: "step3",
    question: "3. Which 2FA method is generally more secure?",
    options: [
      { value: "1", label: "SMS codes" },
      { value: "2", label: "Email" },
      {
        value: Answer.Correct,
        label:
          "Authenticator apps (e.g., Google Authenticator, Authy, Microsoft Authenticator)",
      },
      { value: "4", label: "Security questions" },
    ],
  },
  {
    name: "step4",
    question:
      "4. In Google Workspace (Gmail), what can admins do to quickly improve security?",
    options: [
      { value: "1", label: "Disable 2FA to reduce support tickets" },
      { value: "2", label: "Ask users to change passwords every week" },
      {
        value: Answer.Correct,
        label: "Enforce 2FA for all users via Admin Console",
      },
      { value: "4", label: "Turn off password complexity requirements" },
    ],
  },
  {
    name: "step5",
    question: "5. Where is the best place to store 2FA recovery codes?",
    options: [
      { value: "1", label: "In a chat with yourself" },
      { value: "2", label: "On a sticky note under the keyboard" },
      {
        value: Answer.Correct,
        label: "In a password manager or secure storage",
      },
      { value: "4", label: "Nowhere—they aren’t needed" },
    ],
  },
];

export const password2FaSlides: Array<ISlides> = [
  { id: 1, content: <img src={Password2FaS1} alt="slide1" /> },
  { id: 2, content: <img src={Password2FaS2} alt="slide2" /> },
  { id: 3, content: <img src={Password2FaS3} alt="slide3" /> },
  { id: 4, content: <img src={Password2FaS4} alt="slide4" /> },
  { id: 5, content: <img src={Password2FaS5} alt="slide5" /> },
  { id: 6, content: <img src={Password2FaS6} alt="slide6" /> },
];
